/** The search of `/tickets/$ticketId`: the tab it opens on (`AM-496`). */
export interface TicketSearch {
  tab?: 'time';
}

/**
 * `?tab=time` opens the ticket on its hours, as the number of hours of a ticket in the file of its
 * customer does (rule 16 of the billing model: a number opens the list of what it adds up). Anything
 * else is dropped, never thrown on.
 */
export function ticketSearchSchema(search: Record<string, unknown>): TicketSearch {
  return search['tab'] === 'time' ? { tab: 'time' } : {};
}
